
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import http from './http/http';
import { PublicPathPlugin } from './plugins/public-path-plugin';

// needed because of build
import gsap, { CSSPlugin } from 'gsap';
gsap.registerPlugin(CSSPlugin);

Vue.config.productionTip = false;

Vue.use(PublicPathPlugin);

// autoRegisterBaseComponents();

// get the JWT from the local storage
if (localStorage.getItem('JWT')) {
    // store the JWT in the store
    store.dispatch('user/jwt', localStorage.getItem('JWT'));

    // get the rest of the info
    http.get('/userInfo')
        .then((response) => {
            // store them in the store
            store.dispatch('user/userData', response.data);
            // set the menu data
            store.dispatch('menu/menuItems');
            store.dispatch('user/setLastTime');

            /* eslint-disable no-new */
            new Vue({
                el: '#app',
                router,
                store,
                render: h => h(App)
            });
        });
} else {
    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        router,
        store,
        render: h => h(App)
    });
}
